export const downloadBlob = (blob, fileName = 'file.eff') => {
    const tempElement = document.createElement('a')
    tempElement.href = URL.createObjectURL(blob)
    tempElement.setAttribute('download', fileName)
    tempElement.click();
    URL.revokeObjectURL(tempElement.href)
}



// WEBPACK FOOTER //
// ./src/shared/utils/downloadBlob.js